import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
} from "tea-component";

import EngagementTrend from './EngagementTrend';
import { TAB_NAME } from '../../_config/constant';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { PUBG_GAME_CODE_LIST } from '@/pages/dashboard/_config/constant';
import { getDefaultDateValue } from '@/pages/dashboard/_config/defualtTime';

import './index.scss'


interface Props {
  gameCode: string;
  filterLoading: boolean;
  formValue: any;
}

const NoSpendEngagementTrend = (props: Props) => {
  const { formValue, filterLoading, gameCode } = props;
  const { filterValue, timeType, diff} = formValue
  const { rangeTime, ...filters } = filterValue || {};
  const isPUBGM = PUBG_GAME_CODE_LIST.includes(gameCode)
  const defaultTimeRange = getDefaultDateValue(filterValue?.timeType,false,isPUBGM);
  const timeRangeArr = diff ? defaultTimeRange : rangeTime;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false)

  const update = () => {
    // 非继承，第一次进入页面折线图区14天、6周、6月
    const params = {
      period: TAB_NAME[timeType],
      game_code: gameCode,
      start_time: timeRangeArr[0],
      end_time: timeRangeArr[1],
      filters:formatFilterValues(filters),
    };

    setLoading(true);
    setError(false);
    dashboardRequest({
      url: `/api/v1/dashboard/ua/no_spend/engagement_trend`,
      method: 'post',
      data: params,
    })
      .then((data: any) => {
        setData(data?.nodes);
        setError(false)
      })
      .catch((err) => {
        console.log(err);
        setError(true)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (filterLoading) return;
    update();
  }, [formValue, filterLoading]);

  return (
    <Row className='dbd-ua-no-spend-trends-box'>
      <Col span={24}>
        <EngagementTrend
          loading={loading}
          error={error}
          data={data}
          timeType={timeType}
        />
      </Col>
    </Row>
  );
};

export default NoSpendEngagementTrend;
